import React from 'react';
import { useSecondDocumentFormPresenter } from './SecondDocumentForm.presenter';

import { InputMask } from 'utils/inputMask';
import { getDocTypeField } from './SecondDocumentForm.helpers';
import { VOID_FUNCTION } from 'constants';
import { KEY_COMPONENTS } from 'components/modules/MainAnketa/MainAnketa.constants';
import { NAMES, SECOND_DOCUMENT_FORM_LABELS, SYS_NAMES } from './SecondDocumentForm.constants';

import { InfoSvg, AlertSvg, CheckSvg } from 'assets/img';
import { AnketaChevronStyled, ReactTooltipStyled } from '../../../MainAnketa.styles';
import * as S from './SecondDocumentForm.styles';

export const SecondDocumentForm = ({
  persona,
  validate,
  errors,
  isContentHidden = false,
  disabled = false,
  onChange = VOID_FUNCTION,
}) => {
  const presenter = useSecondDocumentFormPresenter({
    persona,
    validate,
    errors,
    isContentHidden,
    onChange,
  });

  const { secondDocFormValues } = presenter;

  if (!secondDocFormValues) {
    return null;
  }

  return (
    <S.FormGridRow id={KEY_COMPONENTS.SECOND_DOCUMENT}>
      <S.FormHeader
        collapsed={isContentHidden || !presenter.showMore}
        data-test={`${KEY_COMPONENTS.SECOND_DOCUMENT} ${
          isContentHidden || !presenter.showMore ? 'collapsed' : 'expanded'
        }`}
        onClick={presenter.onHeaderClick}
      >
        <AnketaChevronStyled className="chevron" />
        <h3>{presenter.getSecondDocHeader}</h3>

        {!disabled && (
          <S.AreaInfo>
            {presenter.shouldShowCheckIcon ? (
              <>
                <CheckSvg className="check" data-tip="" data-for="secDocCheckInfo" />
                <ReactTooltipStyled id="secDocCheckInfo" place="right">
                  <span>Распознан</span>
                </ReactTooltipStyled>
              </>
            ) : presenter.shouldShowAlertIcon ? (
              <>
                <AlertSvg className="alert" data-tip="" data-for="secDocAlertInfo" />
                <ReactTooltipStyled id="secDocAlertInfo" place="right">
                  <span>Загрузите документ</span>
                </ReactTooltipStyled>
              </>
            ) : null}
          </S.AreaInfo>
        )}
      </S.FormHeader>

      {!isContentHidden && presenter.showMore && (
        <>
          <S.SecondDocumentInput
            d={`${KEY_COMPONENTS.SECOND_DOCUMENT}_${NAMES.SECOND_DOCUMENT_INPUT}`}
            tabIndex="42"
            label={SECOND_DOCUMENT_FORM_LABELS[NAMES.SECOND_DOCUMENT_INPUT]}
            name={NAMES.SECOND_DOCUMENT_INPUT}
            defaultValue={presenter.secondDocValue}
            val={presenter.secondDocValue}
            error={
              presenter.getError(
                `${KEY_COMPONENTS.SECOND_DOCUMENT}.currentSecondDocumentType.sysName`
              ) ||
              presenter.getError(
                `${KEY_COMPONENTS.SECOND_DOCUMENT}.${getDocTypeField(presenter.secondDocType)}`
              )
            }
            mask={[
              InputMask.ZPASSPORT_SERIA_NUMBER[0],
              InputMask.ARMY_SERIAL_NUMBER[0],
              InputMask.DRIVE_LICENSE_SERIES_NUMBER[0],
              InputMask.SNILS[0],
              InputMask.INN_PRIVATE[0],
            ]}
            unmask
            required
            disabled={disabled}
            onChange={presenter.changeHandlerSecondDoc}
            onBlur={() => {
              presenter.validation(
                `${KEY_COMPONENTS.SECOND_DOCUMENT}.currentSecondDocumentType.sysName`
              );
              presenter.validation(
                `${KEY_COMPONENTS.SECOND_DOCUMENT}.${getDocTypeField(presenter.secondDocType)}`
              );
            }}
          />
          <S.DateAreaInfo showDate={presenter.getShowDate()}>
            <InfoSvg data-tip="" data-for="secDocInfo" data-test="secDocInfoSvg" />
            <ReactTooltipStyled id="secDocInfo" place="right">
              Введите серию и номер документа согласно маске:
              <br />
              ВУ - 1234 123456
              <br />
              СНИЛС - 123-123-123 12
              <br />
              Загран паспорт - 12 1234567
              <br />
              Военный билет - ХХ 1234567
              <br />
              ИНН - 123456789012
            </ReactTooltipStyled>
          </S.DateAreaInfo>

          {presenter.secondDocType?.sysName === SYS_NAMES.SECOND_FOREIGN_PASSPORT && (
            <S.PassportDate
              id={`${KEY_COMPONENTS.SECOND_DOCUMENT}_${NAMES.INTERNATIONAL_PASSPORT}_${NAMES.ISSUE_DATE}`}
              tabIndex="30"
              label={SECOND_DOCUMENT_FORM_LABELS[NAMES.ISSUE_DATE]}
              name={NAMES.ISSUE_DATE}
              defaultValue={secondDocFormValues[NAMES.INTERNATIONAL_PASSPORT]?.[NAMES.ISSUE_DATE]}
              val={secondDocFormValues[NAMES.INTERNATIONAL_PASSPORT]?.[NAMES.ISSUE_DATE]}
              error={presenter.getError(
                `${KEY_COMPONENTS.SECOND_DOCUMENT}.${NAMES.INTERNATIONAL_PASSPORT}.${NAMES.ISSUE_DATE}`
              )}
              mask={InputMask.DATE_BEFORE_TODAY}
              unmask
              required
              disabled={disabled}
              onChange={presenter.changeHandlerPassportDate}
              onBlur={() =>
                presenter.validation(
                  `${KEY_COMPONENTS.SECOND_DOCUMENT}.${NAMES.INTERNATIONAL_PASSPORT}.${NAMES.ISSUE_DATE}`
                )
              }
            />
          )}

          {presenter.secondDocType?.sysName === SYS_NAMES.SECOND_DRIVER && (
            <S.DriverLicenseDate
              id={`${KEY_COMPONENTS.SECOND_DOCUMENT}_${NAMES.DRIVER_LICENSE}_${NAMES.ISSUE_DATE}`}
              tabIndex="25"
              label={SECOND_DOCUMENT_FORM_LABELS[NAMES.ISSUE_DATE]}
              name={NAMES.ISSUE_DATE}
              defaultValue={secondDocFormValues[NAMES.DRIVER_LICENSE]?.[NAMES.ISSUE_DATE]}
              val={secondDocFormValues[NAMES.DRIVER_LICENSE]?.[NAMES.ISSUE_DATE]}
              error={presenter.getError(
                `${KEY_COMPONENTS.SECOND_DOCUMENT}.${NAMES.DRIVER_LICENSE}.${NAMES.ISSUE_DATE}`
              )}
              mask={InputMask.DATE_BEFORE_TODAY}
              unmask
              required
              disabled={disabled}
              onChange={presenter.changeHandlerDriverLicenseDate}
              onBlur={() =>
                presenter.validation(
                  `${KEY_COMPONENTS.SECOND_DOCUMENT}.${NAMES.DRIVER_LICENSE}.${NAMES.ISSUE_DATE}`
                )
              }
            />
          )}
        </>
      )}
    </S.FormGridRow>
  );
};
